import { Shape } from '@/services/shape';
import {
  addResourceIfNotExists,
  generateLayoutAst,
  insertImages
} from '../utils/resource.utils';
import { apkFileAttribute } from '@/services/shape/attributes/apk-file';
import { generateResourceName, getRefName } from '../utils/name.utils';
import { buildAstState } from '..';

export const getApkFileAst = (resourceAst: Ast, shape: Shape) => {
  const attrs = shape.attrs as apkFileAttribute;
  const { apkFilename, apkInfoName, format, resources } = attrs;
  const layoutAsts: Ast[] = [];
  const apkPreview = resources?.apkPreview;
  if (buildAstState.options.buildFor == 'export') {
    if (!apkFilename || !apkInfoName) return;
    const apkFileAst: Ast = {
      tag: 'File',
      attrsMap: {
        fileName: apkFilename,
        name: generateResourceName(resourceAst, 'File')
      },
      children: []
    };

    const apkInfoAst: Ast = {
      tag: 'File',
      attrsMap: {
        fileName: apkInfoName,
        name: `File${Number(apkFileAst.attrsMap.name.replace('File', '')) + 1}`
      },
      children: []
    };

    addResourceIfNotExists(resourceAst, apkFileAst, undefined, true);
    addResourceIfNotExists(resourceAst, apkInfoAst, undefined, true);

    // 为解决app上预览图bug，增加一个预览图字段
    if (apkPreview) {
      const imageMap = insertImages(
        resourceAst,
        { apkPreview: apkPreview },
        { recolorEnable: !!attrs.recolorEnable }
      );
      apkFileAst.attrsMap['preview'] = getRefName(imageMap['apkPreview']);
    }

    // 生成 layout ast
    const layoutApkAst: Ast = generateLayoutAst({
      ref: '@' + apkFileAst.attrsMap.name,
      x: attrs.x,
      y: attrs.y
    });
    const layoutInfoAst: Ast = generateLayoutAst({
      ref: '@' + apkInfoAst.attrsMap.name,
      x: attrs.x,
      y: attrs.y
    });
    layoutAsts.push(layoutApkAst, layoutInfoAst);
  } else {
    // 编辑器使用时，仅添加预览图
    const imageMap = insertImages(resourceAst, attrs.resources, {
      recolorEnable: attrs.recolorEnable,
      imgFormat: format
    });
    // 生成 layout ast
    const layoutAst: Ast = generateLayoutAst({
      ref: getRefName(imageMap['apkPreview']),
      x: attrs.x,
      y: attrs.y
    });
    layoutAsts.push(layoutAst);
  }
  return layoutAsts;
};
